module.exports = __webpack_public_path__ + "static/media/hero3.beb2f8ea.png";